import { JitsiMeeting } from '@jitsi/web-sdk/lib/components';
import { connect } from 'react-redux';
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { User } from 'modules/user/types';
import participantImg from 'assets/svg/user_white.svg';
import CustomModal from 'components/customModal/CustomModal';
import InviteFriend from 'views/inviteFriend';
import { useHistory } from 'react-router';
import { deleteRoom, updateParticipantsInRoom, updateCallStatus, useGetCallStatus } from 'store/services/firebase-broadcast';
import Styles from 'components/Jitsi/Jitsi.module.scss';
import Button from 'components/button/Button';
import { IMAGE_URL } from 'store/services/URL';
import { setLoggedTimeRequest } from 'store/actions/general.actions';
import { useDispatch } from 'react-redux';
import { getLoggedTimeStatus } from 'store/selector/general.selector';
import api from 'store/services/conversation.service';

type participant = { id: string; name: string };

interface JitsiProps {
  user: User;
  broadCast: any;
  handleClose: Function;
  loggedTime?: string;
}

const Jitsi: FunctionComponent<JitsiProps> = (props: JitsiProps) => {
  const { user, broadCast, handleClose, loggedTime } = props;
  const dispatch = useDispatch();
  const room = broadCast;
  const apiRef = useRef<any>();
  const [host, setHost] = useState<any>({});
  const [name, setName] = useState('');
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [confirmEndCall, setConfirmEndCall] = useState<boolean>(false);
  const [showChat, setShowChat] = useState<boolean>(true);
  const [logItems, updateLog] = useState<string[]>([]);
  const [noOfParticipants, setNoOfParticipants] = useState(0);
  const [knockingParticipants, updateKnockingParticipants] = useState<participant[]>([]);
  const history = useHistory();
  const [token, setToken] = useState(null);
  const requestRef = useRef<any>();

  console.log('Jitsi component props:', { user, broadCast, room, host });

  const closeDialog = () => {
    setShowPopup(false);
    setConfirmEndCall(false);
  };

  const handleBack = () => {
    setConfirmEndCall(true);
  };

  const handleConfirmLeft = () => {
    setConfirmEndCall(false);
    handleReadyToClose();
  };

  useEffect(() => {
    console.log('Setting host from room:', room);
    setHost(room.host);
  }, [room]);

  useEffect(() => {
    console.log('Host state updated:', host);
    if (host !== undefined) {
      setName(host.name);
    }
  }, [host]);

  useEffect(() => {
    // get the token and then join the room
    console.log('Token generation check:', {
      token,
      requestRef: requestRef.current,
      broadCast,
      broadCastTopic: broadCast?.topic,
      host,
      user,
      shouldGenerate: token === null && !requestRef.current && broadCast && broadCast.topic && host && user
    });
    
    if (token === null 
      && !requestRef.current 
      && broadCast 
      && broadCast.topic 
      && host 
      && user) {
      requestRef.current = true;
      console.log('Generating room token for:', broadCast.topic);
      
      api.getRoomToken({
        moderator: host.pk === user.pk ? 'owner' : 'member',
        room: broadCast.topic
      }).then((res) => {
        console.log('Room token received:', res);
        setToken(res.meeting_token);
        requestRef.current = false;
      }).catch((error) => {
        console.error('Failed to get room token:', error);
        requestRef.current = false;
      });
    }
  },[broadCast, host, user]);

  useEffect(() => () => {
        if (apiRef && apiRef.current) {
          apiRef.current.dispose();
        }
      }, []);

  const endCallModal = () => {
    return (
      <div className={Styles.modalWrapper}>
        <h4 className={Styles.description}>Are you sure you want to close this room?</h4>
        <Button label="Confirm" clickHandler={handleConfirmLeft} />
        <div onClick={closeDialog} onKeyPress={closeDialog} tabIndex={0} role="button">
          <p className="text-uppercase text-decoration-none mt-2 d-inline-block text-blue font-weight-600 fontFourteen">
            Close
          </p>
        </div>
      </div>
    );
  };

  const printEventOutput = (payload: any) => {
    updateLog((items: string[]) => [...items, JSON.stringify(payload)]);
  };

  const handleAudioStatusChange = (payload: any, feature: any) => {
    if (payload.muted) {
      updateLog((items) => [...items, `${feature} off`]);
    } else {
      updateLog((items) => [...items, `${feature} on`]);
    }
  };

  const handleChatUpdates = (payload: any, ref: any) => {
    if (payload.isOpen || !payload.unreadCount) {
      return;
    }
    ref.current.executeCommand('toggleChat');
    updateLog((items: string[]) => [...items, `you have ${payload.unreadCount} unread messages`]);
  };

  const handleKnockingParticipant = (payload: participant) => {
    updateLog((items: any) => [...items, JSON.stringify(payload)]);
    updateKnockingParticipants((participants: participant[]) => [...participants, payload]);
  };

  const handleParticipantLeft = (payload: participant) => {
    console.log('Left Participant', payload);
    // setNoOfParticipants(noOfParticipants - 1);
  };

  const handleParticipantJoined = (payload: participant) => {
    // setNoOfParticipants(noOfParticipants + 1);
    console.log('Participant Joined', payload, user);
  };

  const resolveKnockingParticipants = async () => {
    const data: any = apiRef.current.getParticipantsInfo();
    // console.log('[resolveKnockingParticipants]', ref, condition);
    // knockingParticipants.forEach((p: participant) => {
    //   ref.current.executeCommand('answerKnockingParticipant', p?.id, condition(p));
    //   updateKnockingParticipants((participants) => participants.filter((item) => item.id === p.id));
    // });
  };

  const handleJitsiIFrameRef1 = (iframeRef: any) => {};

  const handleReadyToClose = () => {
    // Call hangup first to leave conference cleanly, which may prevent notification
    if (apiRef.current) {
      try {
        apiRef.current.executeCommand('hangup');
      } catch (e) {
        // If hangup fails, just dispose
        if (apiRef.current) {
          apiRef.current.dispose();
        }
      }
    }
    
    // Log time (async, but don't wait for it)
    handleLoggedTime();
    
    // Always call handleClose for cleanup and navigation (both hosts and non-hosts)
    handleClose();
  };

  const handleLoggedTime = () => {
    const startTime = localStorage.getItem('start_time');
    if (startTime !== null) {
      const endTime = +new Date();
      const totalTime =  endTime - parseInt(startTime);
      dispatch(setLoggedTimeRequest({
        total_spend_time:	Math.floor(totalTime / 60000),
        room_id: room.pk.toString(),
      }));
    }
    localStorage.removeItem('start_time');
    // history.push('/conversations-nearby');
    // window.location.reload();
  };

  const handleJoinParticipant = (e: any) => {
    const participants = broadCast.participants;
    const obj = {
      roomId: room.pk,
      user: [...participants,user],
    }
    if (host.pk !== user.pk) {
      updateParticipantsInRoom(obj).then((e) => console.log('Participant Added', e));
    }
  };

  useEffect(() => {
    if(loggedTime) {
      history.push('/conversations-nearby');
      window.location.reload();
    }
  }, [loggedTime])

  const handleVideoConferenceLeft = (e: any) => {
    setShowChat(false);
    if (e.pk) {
      handleClose();
    }
  };

  const handleParticipantKickedOut = (e: any) => {
    handleLoggedTime();
    history.push('/conversations-nearby');
    window.location.reload();
  };

  const handleApiReady = (apiObj: any, ref: any) => {
    try {
      console.log('Jitsi API ready, setting up event listeners');

      // Fix for iOS Safari suspended AudioContext
      const resumeAudioContext = () => {
        // Resume outer AudioContext
        const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
        if (AudioContext) {
          const ctx = new AudioContext();
          ctx.resume().then(() => {
            console.log('AudioContext state after resume:', ctx.state);
          });
        }

        // Resume AudioContext INSIDE Jitsi iframe via postMessage
        // const iframe = document.querySelector('iframe');
        // if (iframe && iframe.contentWindow) {
        //   iframe.contentWindow.postMessage(
        //     { type: 'resume-audio-context' },
        //     'https://localhost:8080'  // your local jitsi-meet origin
        //   );
        //   console.log('postMessage sent to iframe');
        // }
      };

      // Try immediately
      resumeAudioContext();

      // Also on any touch — iOS Safari needs this
      document.addEventListener('touchend', resumeAudioContext, { once: true });
      document.addEventListener('click', resumeAudioContext, { once: true });

      const reff: any = ref;
      reff.current = apiObj;
      
      // Add device and track event listeners for diagnostics
      apiObj.addEventListener('deviceListChanged', (devices: any) => {
        console.log('📱 Device list changed:', devices);
      });
      
      apiObj.addEventListener('audioAvailabilityChanged', (e: any) => {
        console.log('🎤 Audio availability changed:', e);
      });
      
      apiObj.addEventListener('videoAvailabilityChanged', (e: any) => {
        console.log('📹 Video availability changed:', e);
      });
      
      reff.current.addEventListeners({
        audioMuteStatusChanged: (payload: any) => handleAudioStatusChange(payload, 'audio'),
        videoMuteStatusChanged: (payload: any) => handleAudioStatusChange(payload, 'video'),
        raiseHandUpdated: printEventOutput,
        tileViewChanged: printEventOutput,
        chatUpdated: (payload: any) => handleChatUpdates(payload, ref),
        knockingParticipant: handleKnockingParticipant,
        participantJoined: handleParticipantJoined,
        participantLeft: handleParticipantLeft,
        readyToClose: handleReadyToClose,
        participantKickedOut: handleParticipantKickedOut,
        videoConferenceLeft: (e: any) => {
          if (apiRef.current) {
            try {
              apiRef.current.executeCommand('hangup');
            } catch (err) {
              if (apiRef.current) {
                apiRef.current.dispose();
              }
            }
          }
          handleVideoConferenceLeft(e);
        },
      });

      apiObj.addEventListener('videoConferenceJoined', (e: any) => {
        console.log('Video conference joined event:', e);

        // Resume AudioContext again on conference join
        resumeAudioContext();

        if (user?.profile) {
          try {
            apiObj.executeCommand('avatarUrl', `${IMAGE_URL}${user.profile}`);
            console.log('Avatar URL set successfully');
          } catch (avatarError) {
            console.warn('Failed to set avatar URL:', avatarError);
          }
        }

        // iOS: Wait for devices to be available, then unmute
        const ensureUnmuted = async (attempt = 1) => {
          try {
            console.log(`🔄 Attempt ${attempt}: Checking device availability...`);
            
            // Check if devices are available
            const devices = await apiObj.getAvailableDevices();
            console.log('📱 Available devices:', devices);
            
            const hasAudioInput = devices?.audioInput && devices.audioInput.length > 0;
            const hasVideoInput = devices?.videoInput && devices.videoInput.length > 0;
            
            console.log(`Devices ready - Audio: ${hasAudioInput}, Video: ${hasVideoInput}`);
            
            if (!hasAudioInput || !hasVideoInput) {
              if (attempt < 5) {
                console.log('⏳ Devices not ready, retrying in 500ms...');
                setTimeout(() => ensureUnmuted(attempt + 1), 500);
                return;
              } else {
                console.warn('⚠️ Devices still not available after 5 attempts');
              }
            }
            
            // Now check mute states
            const isAudioMuted = await apiObj.isAudioMuted();
            const isVideoMuted = await apiObj.isVideoMuted();
            console.log('Current mute states - Audio:', isAudioMuted, 'Video:', isVideoMuted);
            
            // Unmute if needed
            if (isAudioMuted && hasAudioInput) {
              await apiObj.executeCommand('toggleAudio');
              console.log('✅ Audio unmuted successfully');
            } else if (!hasAudioInput) {
              console.warn('⚠️ Audio input device not available');
            } else {
              console.log('✅ Audio already unmuted');
            }
            
            if (isVideoMuted && hasVideoInput) {
              await apiObj.executeCommand('toggleVideo');
              console.log('✅ Video unmuted successfully');
            } else if (!hasVideoInput) {
              console.warn('⚠️ Video input device not available');
            } else {
              console.log('✅ Video already unmuted');
            }
            
            // Verify final state
            const finalAudioMuted = await apiObj.isAudioMuted();
            const finalVideoMuted = await apiObj.isVideoMuted();
            console.log('✅ Final mute states - Audio:', finalAudioMuted, 'Video:', finalVideoMuted);
            
          } catch (err) {
            console.error('❌ Failed to ensure unmuted:', err);
          }
        };
        
        // Start the unmute process after a small delay
        setTimeout(() => ensureUnmuted(), 1000);

        if (host.pk !== user.pk) {
          const checkParticipant = !!broadCast?.participants.find((item: any) => item?.pk === user?.pk);
          if (!checkParticipant){
            handleJoinParticipant(e);
          }
        }
        setNoOfParticipants(Object.keys(apiObj._participants).length);
      });

      console.log('Jitsi API setup completed successfully');
    } catch (error) {
      console.error('Error setting up Jitsi API:', error);
    }
  };

  useEffect(() => console.log('Local User Joined', noOfParticipants), [noOfParticipants])
  return (
    token ?
    <div className="jitsiMeetingWrapper">
      {(
        <div className="d-flex align-items-center justify-content-between jitsi-header-wrapper">
          <div className={`d-flex align-items-center jitsi-header-left`}>
            <i className={`pr-2 fas fa-chevron-left broadcastBackIcon`} onClick={handleBack} onKeyUp={handleBack} tabIndex={0} role="button" aria-label="Go back" />
            <p className="mb-0 broadcastRoomName" title={room.topic}>{room.topic}</p>
          </div>
          <div className="d-flex justify-content-between align-items-center jitsi-header-right">
            <div className="d-flex align-items-center jitsi-invite-section" onClick={() => setShowPopup(true)} onKeyUp={() => setShowPopup(true)} tabIndex={0} role="button" aria-label="Invite friends">
              <p className={`mb-zero broadCastInviteFriend`}>INVITE FRIENDS</p>
              <i className={`broadcastPlusIcon fa fa-plus`} />
            </div>
            <div className='line jitsi-separator'>|</div>
            <div className="hostWrapper jitsi-host-wrapper">
              <p className="mb-0 hostName" title={`Host: ${name}`}>Host: {name}</p>
            </div>
            <div className="d-flex justify-content-between align-items-center participant-count jitsi-participant-count">
              <img src={participantImg} className="participantIcon" alt="Participants" />
              <p className="mb-0 participants">{noOfParticipants}</p>
            </div>
          </div>
        </div>
      )}
      <JitsiMeeting
        domain="broadcast.socialplay.com"
        roomName={`${room.topic}?jwt=${token}&token=${user.access}&roomId=${room.pk}&userID=${user.pk}`}
        configOverwrite={{
          disableModeratorIndicator: true,
          prejoinPageEnabled: false,
          disableDeepLinking: true,
          disableKick: true,
          enableClosePage: false,
          enableFeedback: false,
          // iOS Safari specific settings
          startWithAudioMuted: false,
          startWithVideoMuted: false,
          // Disable P2P to force media through JVB (better iOS compatibility)
          p2p: {
            enabled: false,
          },
          // iOS media handling
          constraints: {
            video: {
              height: {
                ideal: 720,
                max: 720,
                min: 180
              },
              width: {
                ideal: 1280,
                max: 1280,
                min: 320
              }
            }
          },
          // Disable simulcast for iOS (as per your server docs)
          disableSimulcast: true,
          // Help iOS video stay visible
          enableLayerSuspension: false,
        }}
        interfaceConfigOverwrite={{
          SHOW_JITSI_WATERMARK: false,
          SHOW_PROMOTIONAL_CLOSE_PAGE: false,
          CLOSE_PAGE_GUEST_HINT: false,
          DISABLE_FOCUS_INDICATOR: true,
          // iOS specific interface settings
          MOBILE_APP_PROMO: false,
        }}
        onApiReady={(externalApi) => handleApiReady(externalApi, apiRef)}
        getIFrameRef={handleJitsiIFrameRef1}
      />
      {showPopup && (
        <CustomModal heightClass="inviteFriendModal">
          <InviteFriend cssClass="inviteFriendPopupWrapper" isPopup={showPopup} closePopup={closeDialog} />
        </CustomModal>
      )}
      {confirmEndCall && (
        <CustomModal heightClass="inviteFriendModal" closeDialog={closeDialog}>
          {endCallModal()}
        </CustomModal>
      )}
    </div> : null
  );
};

const mapStateToProps = (state: any) => {
  const loggedTime = getLoggedTimeStatus(state);
  return { loggedTime };
};

export default connect(mapStateToProps, null)(Jitsi);
